export { PromoBox } from './PromoBox';
export type { PromoBoxProps } from './PromoBox';
